import { Link, useNavigate, useParams } from '@tanstack/react-router';
import { toast } from 'sonner';
import { LoanForm } from '@/features/loans/LoanForm';
import { useCreateLoan } from '@/features/loans/queries';
import { apiErrorMessage } from '@/lib/api';

export function NewLoanPage() {
  const { propertyId } = useParams({ strict: false }) as { propertyId: string };
  const id = Number(propertyId);
  const navigate = useNavigate();
  const createLoan = useCreateLoan(id);

  return (
    <div className="flex flex-col gap-6">
      <Link
        to="/biens/$propertyId"
        params={{ propertyId }}
        className="text-sm text-muted-foreground hover:underline"
      >
        ← Retour au bien
      </Link>
      <h1 className="text-2xl font-semibold">Nouveau prêt</h1>
      <LoanForm
        isPending={createLoan.isPending}
        onSubmit={(input) =>
          createLoan.mutate(input, {
            onSuccess: (loan) => {
              void navigate({ to: '/biens/$propertyId/prets/$loanId', params: { propertyId, loanId: String(loan.id) } });
            },
            onError: (error) => {
              toast.error(apiErrorMessage(error, 'Échec de la création'));
            },
          })
        }
      />
    </div>
  );
}
